<template>
  <app-base-main
    :hasMagin="false"
    :no-padding="true"
    parentTable
    :table-border-top="true"
    :table-shadow="false"
  >
    <template #filter-group>
      <app-filter-group
        advancedFiltering
        :fixWidth="200"
        :screenOptons="screenOptons"
        @determine="filterQuery"
        @clear="filterQuery"
        @query="$gjNoticeQuery"
        @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SP" @change="campaignSelectChange($event)" width="180px"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SP"></ad-group-select>
        <gj-select
          v-model="filter.matchType"
          :options="options.matchType"
          placeholder="匹配类型"
        ></gj-select>
        <gj-select
          v-if="false"
          v-model="filter.effectivenessType"
          :options="AdSearchWordEnum.SP.effectivenessTypeOption"
          placeholder="词表现"
        ></gj-select>
        <gj-select
          v-if="!inCampaign && !inGroup"
          v-model="filter.targetingType"
          :options="AdCampaignEnum.SP.targetingTypeOption"
          placeholder="活动类型"
        ></gj-select>
        <gj-select-input
          v-model="filter.query"
          :options="[
            { id: 0, text: '模糊查询' },
            { id: 1, text: '精准查询' },
          ]"
          :placeholder="['', '用户搜索词']"
          :width="['100px', '120px']"
        ></gj-select-input>
        <gj-select-input
          v-model="filter.keyword"
          :options="[
            { id: 0, text: '模糊查询' },
            { id: 1, text: '精准查询' },
          ]"
          :placeholder="['', '关键词']"
          :width="['100px', '100px']"
        ></gj-select-input>
        <gj-date-picker
          v-model="filter.date"
          type="daterange"
          :clearable="false"
          tooltip="数据时间"
          :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
            :helpName="helpName"
            help
            setting
            :table-name="tableName"
            :table-columns="columns"
            :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/searchKeywords/export" :download-params="globalParams"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button :disabled="noSelect" @click="setKeyword">
        设为关键词
      </gj-button>
      <gj-button :disabled="noSelect" @click="setNegKeyword">
        设为否定关键词
      </gj-button>
      <gj-button :disabled="showNegProduct" @click="setProduct">
        设为商品投放
      </gj-button>
      <gj-button :disabled="showNegProduct" @click="setNegProduct">
        设为否定商品投放
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
        :helpName="helpName"
        help
        setting
        :table-name="tableName"
        :table-columns="columns" :sort-gjtable="$refs.gjTable"
        :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/searchKeywords/export" :download-params="globalParams"
      >
      <template #before>
        <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
      </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
        ref="gjTable"
        adaptParent
        :name="tableName"
        :selection="$permission('adsSpCampaigns:addOrUpdate')"
        size="has-picture"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        sortable="custom"
        :show-header-overflow="true"
        :show-footer-overflow="true"
        :pagination="pagination"
        show-summary :summary-object="sumRecord"
        :show-overflow="true"
        :scroll-y="{mode: 'wheel', oSize:10, gt: 40 }"
        :default-sort="defaultSort"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery"
      >
        <template v-slot:imageUrl="{ row }">
          <gj-image :src="row.imageUrl" v-if="row.orAsin===0"></gj-image>
        </template>
        <template v-slot:query="{ row }">
          <div>
            <img src="./img/neg.png" class="negImg" v-if="row.negative === 0" />
            <gj-link
              :href="row.amazonQueryUrl"
              target="_blank"
              :class="[row.negative === 1 && 'notNeg']">
              <gj-tooltip :text-line="2" :content="row.query">
                {{ row.query | defaultShow }}
              </gj-tooltip>
            </gj-link>
          </div>
        </template>
        <template v-slot:keywordText="{ row }">
            <gj-link :href="row.amazonUrl" target="_blank">
              <gj-tooltip :text-line="2" :content="row.keywordText">
                {{row.keywordText | defaultShow }}
              </gj-tooltip>
            </gj-link>
        </template>
        <template v-slot:belongCampaign="{ row }">
          <app-sp-ad-route-link
            :ad-campaign-manager="{ marketId, campaign: row }"
          >
            <gj-tooltip :text-line="2" :content="row.campaignName">
              {{ row.campaignName | defaultShow }}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:belongGroup="{ row }">
          <app-sp-ad-route-link
            :ad-group-manager="{ marketId, campaign: row, group: row }"
          >
            <gj-tooltip :text-line="2" :content="row.groupName">
              {{ row.groupName | defaultShow }}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import {
  adDefaultSortMixin,
  adAdvancedFilteringMixin,
  currencySymbolMixin,
  inCampaignMixin,
  inGroupMixin,
  initDateMixin,
  inMarketMixin,
  inPortfolioMixin,
  resizeMixin,
  tableNameMixin,
} from "modules/ad/common/mixin";
import {
  AdCampaignEnum,
  AdKeywordEnum,
  AdSearchWordEnum,
} from "modules/ad/common/enum";
import {
  isMeaningful,
  isMeaningless,
  defaultVal,
} from "@/utils/common";
import AppSetKeywordModal from "../../common/modal/set-keyword/set-keyword-modal";
import AppSetNegKeywordModal from "../../common/modal/set-keyword/set-neg-keyword-modal";
import AppSetProductModal from "../../common/modal/set-keyword/set-product-modal";
import AppSetNegProductModal from "../../common/modal/set-keyword/set-neg-product-modal";
import AppSpAdRouteLink from "../../common/components/ad-route-link";
import { adFields } from "modules/ad/common/fields";
import { adStore } from "modules/ad/common/store";
import { queryMixin, selectionMixin } from "@/minxins";
import { convertToDate } from "@/utils/date.util";
import { tagColors } from "@/components/tag/tag-colors";
import { getSpAdSearchWordPage, SP } from "@/api/ad";
import { subDays } from "date-fns";
import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
import { getAsinInfo } from '@/views/modules/ad/config'

export default {
  name: "app-sp-ad-search-keyword",
  components: { AppSpAdRouteLink, AdCampaignSelect, AdGroupSelect},
  mixins: [
    inMarketMixin,
    inPortfolioMixin,
    resizeMixin,
    inCampaignMixin,
    inGroupMixin,
    tableNameMixin,
    selectionMixin,
    queryMixin,
    currencySymbolMixin,
    adDefaultSortMixin,
    adAdvancedFilteringMixin,
    initDateMixin,
  ],
  created() {
    this.columns = [
      { id: "imageUrl", header: "图片", field: "slot:imageUrl", width: "55px", fixed: "left", default: true, disabled: true,},
      { ...adFields.searchWordName, minWidth: "300px", help: "部分广告数据需要48小时才能更新完整，所以在某些时间范围内数据会有所延迟",},
      { ...adFields.keywordName, fixed: null, header: "关键词/商品投放" },
      { ...adFields.matchType, options: this.options.matchType },
      this.inCampaign ? null : { ...adFields.campaignType, field: "option(badge):targetingType", options: AdCampaignEnum.SP.targetingTypeOption },
      this.inCampaign ? null : adFields.belongCampaign,
      this.inGroup    ? null : adFields.belongGroup,
      adFields.impressions,
      adFields.clicks,
      adFields.ctr,
      adFields.cost,
      adFields.cpc,
      adFields.orders,
      adFields.cvr,
      adFields.cpa,
      adFields.sales,
      adFields.acos,
      adFields.roas,
    ].filter((e) => e !== null);
  },
  inject: [ 'getCornerMark' ],
  data() {
    return {
      helpName:'spadmanager',
      lastUpdatedDate: "",
      countryName: '',
      sumRecord: {},
      campaignIds: [],
      groupIds: [],
      tableData: [],
      columns: [],
      AdKeywordEnum: AdKeywordEnum,
      AdSearchWordEnum: AdSearchWordEnum,
      AdCampaignEnum: AdCampaignEnum,
      filter: {
        matchType: null,
        effectivenessType: null,
        targetingType: null,
        query: {
          key: 0,
          value: null,
        },
        keyword: {
          key: 1,
          value: null,
        },
        extendSearch: null,
        date: [subDays(new Date(), 6), new Date()],
      },
      options: {
        matchType: [
          {id: 0, text: '精确匹配', ...tagColors.green},
          {id: 1, text: '词组匹配', ...tagColors.violet},
          {id: 2, text: '广泛匹配', ...tagColors.orange},
          {id: 3, text: '紧密匹配', ...tagColors.moreGreen},
          {id: 4, text: '宽泛匹配', ...tagColors.moreOrange},
          {id: 5, text: '同类商品', ...tagColors.blue},
          {id: 6, text: '关联商品', ...tagColors.moreBlue},
          {id: 7, text: '分类匹配', ...tagColors.violetText},
        ]
      },
      // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
      filterStoragekey: 'app-sp-ad-search-keyword',
      notStorage: true
    };
  },
  computed: {
    // 控制设为否定商品投放
    showNegProduct() {
      let res = true;
      if (!this.selectedRows.length) {
        return true;
      } else {
        this.selectedRows.map((item) => {
          if (item.negative != 1 || !item.orAsin===0) {
            res = false;
          }
        });
        return !res;
      }
    },
  },
  methods: {
    // 重置参数
    $gjQueryInitParams() {
      return {
        campaignIds: [],
        groupIds: [],
        filter: {
          matchType: null,
          effectivenessType: null,
          campaignType: null,
          keyword: {
            key: 0,
            value: null,
          },
          query: {
            key: 0,
            value: null,
          },
          extendSearch: null,
          date: this.initDate || [subDays(new Date(), 6), new Date()],
        },
      };
    },
    $gjQuery() {
      if (isMeaningless(this.marketId)) return false;
      this.getCornerMark();
      this.getTablePage();
    },
    async getTablePage() {
      this.loading = true;
      // 处理广告活动 & 广告组
      let campaignIds = this.campaignIds || [];
      let groupIds = this.groupIds || [];
      this.campaignId && (campaignIds = [ this.campaignId ]);
      this.groupId && (groupIds = [ this.groupId ]);
      // 构造查询参数
      const params = {
        model: {
          campaignIds,
          groupIds,
          marketId: this.marketId,
          portfolioId: this.portfolioId,
          extendSearch: this.filter.extendSearch,
          targetingType: defaultVal(this.filter.targetingType, null),
          matchType: defaultVal(this.filter.matchType, null),
          searchType: isMeaningful(this.filter.query.value) ? this.filter.query.key : null,
          query: isMeaningful(this.filter.query.value) ? this.filter.query.value : null,
          keywordSearchType: isMeaningful(this.filter.keyword.value)
            ? this.filter.keyword.key
            : null,
          keywordText: isMeaningful(this.filter.keyword.value)
            ? this.filter.keyword.value
            : null,
          startDate: convertToDate(this.filter.date[0]),
          endDate: convertToDate(this.filter.date[1]),
        },
        ...this.queryPagination,
        ...this.querySortEx,
      };
      this.globalParams = params;
      try {
        let { data } = await SP.searchKeywordsPage(params);
        this.sumRecord = data.sumRecord;
        this.lastUpdatedDate = data.lastUpdatedDate;
        this.countryName = data.countryName;
        this.tableData = this.currencySymbolMixin(
          data.records,
          adStore.SP.currencySymbol
        );
        const arr = data.records.filter(item => {
          return item.orAsin === 0
        }).map(item => item.query?.toLocaleUpperCase());
        getAsinInfo('query', this.tableData[0].marketId, data.countryCode, this.tableData, 'imageUrl', arr);
        this.pagination = this.getPagination(data);
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    // 广告活动下拉改变
    campaignSelectChange(e) {
      this.groupIds = []
      let afferent = {
        campaignIds: e
      }
      this.$refs.groupSelect.getOptions('SP', afferent)
    },
    marketChange(marketId) {
      if (isMeaningful(marketId)) {
        this.$gjNoticeQuery();
      }
    },
    portfolioChange(portfolioId) {
      this.$gjNoticeQuery();
    },
    campaignChange(campaignId) {
      this.$gjNoticeQuery();
    },
    groupChange(groupId) {
      this.$gjNoticeQuery();
    },
    // 操作前处理 type: 'keyword' | 'product';
    setBefore(items, type) {
      return new Promise(resolve => {
        let partialSupport = null
        let notSupport = null
        let itemsNew = []
        const opt = {
          product: () => {
            itemsNew = items.filter(e => e.orAsin == 0)
            partialSupport = "不支持非ASIN添加到商品投放（否定商品投放），请确认是否过滤"
            notSupport = "不支持非ASIN添加到商品投放（否定商品投放），请重新选择"
          },
          keyword: () => {
            itemsNew = items.filter(e => e.orAsin == 1)
            partialSupport = "不支持非关键词添加到关键词（否定关键词），请确认是否过滤"
            notSupport = "不支持非关键词添加到关键词（否定关键词），请重新选择"
          }
        }
        opt[type]()
        const strategy = [
          {
            condition: itemsNew.length === 0, // 全部不支持
            method: () => {
              this.$message.error(notSupport)
              resolve(false)
            }
          },
          {
            condition: items.length == itemsNew.length, // 全部支持
            method: () => {
              resolve(items)
            }
          },
          {
            condition: items.length > itemsNew.length, // 部分支持
            method: () => {
              const modal = this.$gjCreate('gj-info-modal', {
                props: {
                  title: "确认",
                  content: partialSupport
                },
                on: {
                  cancel: () => {
                    modal.$gjDestroy()
                    resolve(false)
                  },
                  confirm: () => {
                    modal.$gjDestroy()
                    resolve(itemsNew)
                  }
                }
              });
            }
          },
        ]
        strategy.find(e => e.condition)?.method()
      })
    },
    // 设为关键词
    async setKeyword() {
      const items =  await this.setBefore(this.selectedRows, 'keyword')
      if(!items) return false
      this.$gjCreate(AppSetKeywordModal, {
        props: {
          marketId: this.marketId,
          items,
        },
        on: {
          created:() => {
            this.$gjResetPage();
          },
        },
      });
    },
    // 设为否定关键词
    async setNegKeyword() {
      const items =  await this.setBefore(this.selectedRows, 'keyword')
      if(!items) return false
      this.$gjCreate(AppSetNegKeywordModal, {
        props: {
          marketId: this.marketId,
          items,
        },
        on: {
          created: () => {
            this.$gjResetPage();
          },
        },
      });
    },
    // 设为商品投放
    async setProduct() {
      const items =  await this.setBefore(this.selectedRows, 'product')
      if(!items) return false
      this.$gjCreate(AppSetProductModal, {
        props: {
          marketId: this.marketId,
          items,
        },
        on: {
          created:() => {
            this.$gjResetPage();
          },
        },
      });
    },
    // 设为否定商品投放
    async setNegProduct() {
      const items =  await this.setBefore(this.selectedRows, 'product')
      if(!items) return false
      this.$gjCreate(AppSetNegProductModal, {
        props: {
          marketId: this.marketId,
          items,
        },
        on: {
          created:() => {
            this.$gjResetPage();
          },
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.negImg {
  width: 24px;
  position: relative;
  top: 5px;
  margin-right: 2px;
}
.notNeg {
  margin-left: 26px;
}
</style>
